const mutations = {
  
    ADD_AVISOS_DISCIPLINA (state, value) {

        state.allpolos.push(value)

    },
    ALL_AVISOS_DISCIPLINA (state, value) {

        state.allAvisosDisciplina = value

    },
    ALL_CHAMADOS_ALUNOS(state, value) {

        state.allchamadoaluno = value

    },
    ALL_RESPOSTAS_CHAMADOS(state, value) {

        state.allrespostaschamados = value

    },
    SET_CHAMADO(state, value) {

        state.setchamado = value

    },
    ALL_CHAMADOS_ALUNOS_DISCIPLINA(state, value) {

        state.allChamadosAlunosDisciplina = value

    },
    ALL_RESPOSTAS_CHAMADOS_DISCIPLINA(state, value) {

        state.allrespostaschamadosdisciplina = value

    },
    ALL_CALENDARIO_DISCIPLINA(state, value) {

        state.setCalendarioAcademico = value

    },
}

export default mutations